import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TsrctRuleStatus } from '@/generated/gql/graphql.ts';
import { I18nNamespace } from '~/common/types';

type ColorMap = Record<TsrctRuleStatus, ChipProps['color']>;

const colorMap: ColorMap = {
  [TsrctRuleStatus.DRAFT]: 'default',
  [TsrctRuleStatus.PUBLISHED]: 'success',
  [TsrctRuleStatus.PAUSED]: 'warning',
};

export interface RuleStatusChipProps {
  className?: string;
  status?: `${TsrctRuleStatus}`;
}

export const RuleStatusChip = ({ className, status }: RuleStatusChipProps) => {
  const { t } = useTranslation(I18nNamespace.ruleBuilder);
  return status ? (
    <Chip
      className={className}
      label={t(`RuleStatus.${status}`)}
      color={colorMap[status]}
      data-intercom-target="Rule/StatusChip"
    />
  ) : null;
};
